import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SprobotconfigService } from '../services/sprobotconfigservice.service'
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private TenantUrl: string;
  
  constructor(
    private http: HttpClient,
    private sprobotConfigService: SprobotconfigService) { 
      this.TenantUrl = this.sprobotConfigService.getSetting('Cors:AuthAPIPublic').propertyValue;
    }

  getTenantsForUser(userLogin: any): Observable<any>{
    return this.http.get<any>(this.TenantUrl + '/Subscription/GetTenantsByUser?userName=' + userLogin);
  }
}